import { AppEntities } from "src/config/entities";
import { IListViewField } from "src/components/Shared/ILIstViewField";
import { IListViewCreateDependedDocumentAction } from "src/components/Shared/IListViewCreateDependedDocumentAction";
import { IListViewCreateMoreActions } from "src/components/Shared/IListViewCreateMoreAction";
import { DocumentListViewToolbar } from "src/components/Shared/ListViews/DocumentListViewToolbar";
import { ListView } from "src/components/Shared/ListViews/ListView";
import { DocumentListViewDefaultToolbarButtons } from "src/components/Shared/ListViews/DocumentListViewDefaultToolbarButtons";
import { ListviewToolbarSubmenuButton } from "src/components/Shared/ListViews/ListviewToolbarSubmenuButton";
import { ListviewToolbarMoreActions } from "src/components/Shared/ListViews/ListviewToolbarMoreActions";

const SalesOrdersList = () => {
  const fields: IListViewField[] = [
    {
      fieldName: "companyName",
      title: "Company"
    },
    {
      fieldName: "customerName",
      title: "Customer"
    },
    {
      fieldName: "warehouseName",
      title: "Warehouse"
    },
    {
      fieldName: "divisionName",
      title: "Division"
    },
    {
      fieldName: "currencyName",
      title: "Currency"
    },
    {
      fieldName: "commodityWaybillNo",
      title: "RS No"
    }
  ];
  const createCustomerInvoice = async (data: any) => {
    const dataService = AppEntities.CustomerInvoices.getDataService();
    return await dataService.createBasedAtOrder(data.id);
  };

  const createIncomingBanksInvoice = async (data: any) => {
    try {
      const dataService = AppEntities.IncomingBanks.getDataService();
      return await dataService.createBasedAtOrder(data.id);
    } catch (err) {
      console.log("data", data);
      console.log("error with", err);
    }
  };

  const createDocumentActions: IListViewCreateDependedDocumentAction[] = [
    {
      title: "Customer invoice",
      appEntity: AppEntities.CustomerInvoices,
      createBaseAtFunction: createCustomerInvoice
    },
    {
      title: "Payment from bank",
      appEntity: AppEntities.IncomingBanks,
      createBaseAtFunction: createIncomingBanksInvoice
    }
  ];

  const createMoreActions: IListViewCreateMoreActions[] = [{ title: "Related Documents" }];

  return (
    <>
      <ListView
        createDocumentActions={createDocumentActions}
        fields={fields}
        entity={AppEntities.SalesOrders}
        createDependedDocumentActions={createDocumentActions}
        createMoreActions={[]}
      >
        <DocumentListViewToolbar>
          <DocumentListViewDefaultToolbarButtons>
            <ListviewToolbarSubmenuButton />
          </DocumentListViewDefaultToolbarButtons>
          <ListviewToolbarMoreActions />
        </DocumentListViewToolbar>
      </ListView>
    </>
  );
};

export default SalesOrdersList;
